import type { PaletteMode } from "@mui/material";

interface PaletteColors {
  primary: { main: string };
  secondary: { main: string };
  success: { main: string };
  warning: { main: string };
  error: { main: string };
  info: { main: string };
  background: { default: string; paper: string };
  text: { primary: string; secondary: string; disabled: string };
  divider: string;
}

type Palettes = Record<PaletteMode, PaletteColors>;

export const palettes: Palettes = {
  light: {
    primary: { main: "#007E88" },
    secondary: { main: "#C84318" },
    success: { main: "#2E7D32" },
    warning: { main: "#F9A825" },
    error: { main: "#C62828" },
    info: { main: "#01579B" },
    background: { default: "#FAFAF7", paper: "#FFFFFE" },
    text: { primary: "#1C1917", secondary: "#57534E", disabled: "#A8A29E" },
    divider: "#E7E5E4",
  },
  dark: {
    primary: { main: "#4DD0E1" },
    secondary: { main: "#FF8A65" },
    success: { main: "#66BB6A" },
    warning: { main: "#FFD54F" },
    error: { main: "#EF5350" },
    info: { main: "#29B6F6" },
    background: { default: "#1A1816", paper: "#262220" },
    text: { primary: "#F5F0EB", secondary: "#A8A29E", disabled: "#78716C" },
    divider: "rgba(245, 240, 235, 0.12)",
  },
};
